import styled from 'styled-components';
import Colours, { focus } from './Colours';
import { fontFamilyRegular } from './Fonts';

export const Link = styled.a`
  color: ${Colours.primary};
  ${fontFamilyRegular};

  &:focus {
    ${focus()};
  }
  &:visited {
    color: ${Colours.primary};
  }
`;
